export default "__VITE_ASSET__B8bz5z9h__"